export default __webpack_public_path__ + "static/media/logo404.3ecf26c7.png";